import { map as Rmap } from "ramda";
import api from "@/api";
import { JSConn } from "@/utilities/js-conn";

interface Commodity {
  id: string;
  name: string;
  description: string | null;
  status?: string;
  color: string;
}

interface CommodityState {
  commodities: Commodity[];
  commodity: Commodity | {};
}

const emptyCommodity: Commodity = {
  id: "",
  name: "",
  description: "",
  status: "",
  color: "",
};

const itemDetails = {
  pluralName: "commodities",
  singularName: "commodity",
};

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    commodity: {
      ...jsConn.formParams,
    },
  };
};

const state: CommodityState = {
  commodities: [],
  commodity: {},
};

const mutations = {
  LOAD_COMMODITIES(state: CommodityState, payload: Commodity[]) {
    state.commodities = payload;
  },
  LOAD_COMMODITY(state: CommodityState, payload: Commodity) {
    state.commodity = payload;
  },
};

const actions = {
  needCommodities(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return api.getItems(jsConn, itemDetails).then(jsConn => {
      context.commit("LOAD_COMMODITIES", jsConn.response);
    });
  },
  needCommodity(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api.getItem(jsConn, itemDetails).then(jsConn => {
      context.commit("LOAD_COMMODITY", jsConn.response);
    });
  },
  createCommodity(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .createItem(jsConn, itemDetails)
      .then(jsConn => {
        context.commit("LOAD_COMMODITY", jsConn.response);
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
  updateCommodity(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .updateItem(jsConn, itemDetails)
      .then(jsConn => {
        context.commit("LOAD_COMMODITY", jsConn.response);
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
  deleteCommodity(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);

    return api
      .deleteItem(jsConn, itemDetails)
      .then(jsConn => {
        context.commit("LOAD_COMMODITY", emptyCommodity);
        return Promise.resolve(jsConn);
      })
      .catch(jsConn => {
        return Promise.reject(jsConn);
      });
  },
};

const getters = {
  commodities: (state: CommodityState) => {
    return state.commodities;
  },
  commodity: (state: CommodityState) => {
    return state.commodity;
  },
  commoditiesForTable: (state: CommodityState) => {
    return state.commodities;
  },
  commoditiesForAutocomplete: (state: CommodityState) => {
    // map over the items and just return a label and an id
    return Rmap(commodity => {
      return {
        value: commodity.id,
        label: commodity.name,
      };
    }, state.commodities);
  },
};

const commoditiesModule = {
  state,
  mutations,
  actions,
  getters,
};

export default commoditiesModule;
